<template>
  <!-- title nativo: cortado com reticências, o texto inteiro continua legível ao parar o
       ponteiro — o mesmo tratamento do título do card e do nome da raia. -->
  <span class="instance-identifier" :title="text">{{ text }}</span>
</template>

<script lang="ts">
import {Component, Vue, Prop, toNative} from 'vue-facing-decorator'
import Idea from '@/types/Idea'
import {titleOfInstance} from '@/utils/ontosUtils'

/**
 * O nome de um item numa grade: a coluna que a régua colorida marca.
 *
 * Existe porque as duas grades do app — a listagem e as tabelas de relacionamento da ficha —
 * mostram a mesma coisa e precisam cortá-la do mesmo jeito. O fallback de quem ainda não tem
 * chave preenchida vem do `titleOfInstance`, que já era a regra da ficha e da edição.
 */
@Component({name: 'ontos-instance-identifier'})
class InstanceIdentifier extends Vue {
  @Prop({type: Object, required: true}) readonly instance!: any
  @Prop({type: Object as () => Idea, required: true}) readonly idea!: Idea

  get text(): string {
    return titleOfInstance(this.instance, this.idea)
  }
}

export default toNative(InstanceIdentifier)
</script>

<style scoped>
/* Não quebra linha: o identificador é a âncora da linha, e quebrado empurra as colunas de dado
   para baixo. O teto de largura impede que uma chave longa coma a grade inteira. */
.instance-identifier {
  display: block;
  max-width: 320px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
